export default "__VITE_ASSET__BaAFySQt__"